import { type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useGetCurrentUserQuery } from '@/entities/user/api/getCurrentUser'
import { isSuperAdmin } from '@/shared/lib/rbac'

interface RoleBasedDashboardProps {
	children: ReactNode
}

export const RoleBasedDashboard = ({ children }: RoleBasedDashboardProps) => {
	const { data: userData, isLoading } = useGetCurrentUserQuery()

	if (isLoading) {
		return null // Or a loading spinner
	}

	// Redirect superadmins to admin dashboard
	if (isSuperAdmin(userData)) {
		return <Navigate to='/admin/dashboard' replace />
	}

	// Show regular dashboard for non-superadmin users
	return <>{children}</>
}

